import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import styled from 'styled-components';

import { IconRegularKlarna, Text } from '@notino/react-styleguide';

const Wrapper = styled.div`
  margin-bottom: 1.5rem;
  padding: 0.75rem 0;

  display: flex;
  align-items: center;
  gap: 0.75rem;

  svg {
    min-width: 45px;
    scale: 1.05;
  }
`;

export const Klarna = () => {
  return (
    <Wrapper>
      <IconRegularKlarna width="45px" height="24px" />

      <Text typography="bodySmall">
        <FormattedMessage
          id="pd.klarna.banner.text"
          defaultMessage="Shop now. Pay in 30 days with Klarna"
        />
      </Text>
    </Wrapper>
  );
};
